export enum FieldRenderType {
    Textfield,
    Checkbox,
    Select,
    AutoComplete,
    TextOnly,
    DateTime,
    Header,
}